export default {
  computed: {
    inputError () {
      return null
    },

    hasInputErrors () {
      return false
    }
  },

  methods: {
    hasSectionErrors (errors, section) {
      const sectionErrors = errors[section]

      if (!sectionErrors) {
        return false
      }

      if (errors instanceof Array) {
        return sectionErrors.length > 0
      }

      return Object.keys(sectionErrors).length > 0
    },

    hasError (errors, key, length = false) {
      if (errors) {
        if (errors instanceof Array) {
          return errors.includes(key)
        } else {
          if (errors[key] || Object.values(errors).indexOf(key) > -1) {
            if (length) {
              return Object.keys(errors[key]).length
            }

            return errors[key] ? errors[key] : true
          }
        }
      }

      return false
    },

    getError (errors, key) {
      const error = this.hasError(errors, key)

      return typeof error !== 'boolean' ? error : null
    },

    hasErrorVisitors () {
      return this.hasError(this.errors, 'visitors')
    },

    hasErrorVisitor (visitorKey, field) {
      if (
        this.errors &&
        this.errors.visitors &&
        this.errors.visitors[visitorKey] &&
        this.errors.visitors[visitorKey].personal
      ) {
        return this.hasError(this.errors.visitors[visitorKey].personal, field)
      }

      return false
    },

    getErrorVisitor (visitorKey, field) {
      const error = this.hasErrorVisitor(visitorKey, field)

      return typeof error !== 'boolean' ? error : null
    },

    hasErrorVisitorTransport (visitorKey, transportKey, field) {
      if (
        this.errors &&
        this.errors.visitors &&
        this.errors.visitors[visitorKey] &&
        this.errors.visitors[visitorKey].transports &&
        this.errors.visitors[visitorKey].transports[transportKey]
      ) {
        return this.hasError(this.errors.visitors[visitorKey].transports[transportKey], field)
      }

      return false
    },

    getErrorVisitorTransport (visitorKey, transportKey, field) {
      const error = this.hasErrorVisitorTransport(visitorKey, transportKey, field)

      return typeof error !== 'boolean' ? error : null
    },

    hasErrorVisitorFiles (visitorKey, field) {
      if (
        this.errors &&
        this.errors.visitors &&
        this.errors.visitors[visitorKey] &&
        this.errors.visitors[visitorKey].files
      ) {
        this.form.visitors[visitorKey].docError = true
        return this.hasError(this.errors.visitors[visitorKey].files, field)
      }

      return false
    },

    hasErrorVisitorTransportDriver(visitorKey, transportKey, field) {

      if (
        this.errors &&
          this.errors.visitors &&
          this.errors.visitors[0] &&
          this.errors.visitors[0].transports &&
          this.errors.visitors[0].transports[transportKey] &&
          this.errors.visitors[0].transports[transportKey].drivers &&
          this.errors.visitors[0].transports[transportKey].drivers[visitorKey].personal
      ) {
        return this.hasError(this.errors.visitors[0].transports[transportKey].drivers[visitorKey].personal, field)
      }

      return false
    },

    getErrorVisitorTransportDriver (visitorKey, transportKey, field) {
      const error = this.hasErrorVisitorTransportDriver(visitorKey, transportKey, field)

      return typeof error !== 'boolean' ? error : null
    }
  }
}
